"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAccents = void 0;

const removeAccents = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

exports.removeAccents = removeAccents;